import Control from 'ol/control/Control.js';

class ControlsGroup extends Control {
  constructor(opt_options) {
    const options = opt_options ? opt_options : {};

    const element = document.createElement('div');
    element.className = 'controls-group';

    super({
      element: element,
      target: options.target,
    });

    this.element = element;
  }
}

export default ControlsGroup;
